import i18n from '@/plugins/i18n';
var dt = new Date();
export const forms = [
    {
        type: 'text',
        name: 'year',
        title: 'Yıl',
        default: dt.getYear().toString().substr(-2),
        rules: {required: false},
        modal: [''],
        data: [''],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'month',
        title: 'Ay',
        default: ("0" + (dt.getMonth() + 1)).slice(-2),
        rules: {required: false},
        modal: [''],
        data: [''],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'stock',
        title: i18n.t('dealer.servicesForm.product'),
        rules: {required: false},
        modal: ['product'],
        data: ['product'],
        options: {
            data: [],
            label: 'name',
            track: 'id',
            search: true
        },
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'radio',
        name: 'title',
        title: 'Barkod Başlığı',
        rules: {required: true},
        default: true,
        options: {
            type: 'locale',
            data: [
                {text: 'Ürün Kodu', value: true},
                {text: 'Yok', value: false},
            ],
        },
        modal: ['is_active'],
        data: ['is_active'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'code',
        title: 'Ürün Ön Ek',
        rules: {required: false},
        modal: [''],
        data: [''],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'startNu',
        title: 'Başlangıç No',
        default: 1,
        rules: {required: true, numeric: true},
        modal: [''],
        data: [''],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'length',
        title: 'Numara Hane Sayısı',
        default: 4,
        rules: {required: true, numeric: true, min: 1},
        modal: [''],
        data: [''],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'count',
        title: 'Barcode Adeti',
        rules: {required: true, numeric: true, min: 1},
        modal: [''],
        data: [''],
        additionalButton: false,
        checkBox: false
    },
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/ERP/Stock/forms/barcode.js